<template>
  <form @submit.prevent>
    <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
      <!-- TKP-184 md.80 (karar 2026-10-06): "Kütüphane" ve "Organizasyon sözlüğünden seç" sekmeleri TEK sekme. Arama organizasyon
           sözlüğü + kütüphaneyi birlikte sunar (organizasyonda karşılığı olan kütüphane kalemi ikinci kez listelenmez); birden çok
           veri seçilebilir; kaynaklar ve süreç bazında kategori seçilenlerin hepsine uygulanır. Kütüphaneden gelen seçim
           "kütüphaneden ekle" ucuyla açılır (organizasyon verisi o anda oluşur). -->
      <b-tab active data-test="pick-data-tab">
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("process-data.pick.tab") }}</span>
        </template>
        <!-- TKP-235 m.170: sekme açıklaması kalktı -->
        <h6 class="mt-2">{{ $t("data.text") }}</h6>
        <filter-select id="dataFilter" ref="dataFilter" :options-limit="200" :placeholder="$t('data.select')" :multiple="true" @filter="onDataSearch" :selected="form.datas" @changed="onDatasSelect" />
        <!-- TKP-229: yeni veri eski veri ekleme ekranıyla (ad + kategori zorunlu) açılır, kaydedilince seçime eklenir -->
        <span class="text-primary hand d-inline-block mt-1" data-test="new-data-open" @click="openNewData('pick')">{{ $t("process-data.create-new.link.data") }}</span>
        <node-fields :form="form" @datasources="onDatasourcesSelect" @category="onCategorySelect" />
        <sweet-button @click="saveSelected()" type="submit" :loading="isUpdating || pickSaving" :disabled="isUpdating || pickSaving || !form.datas.length" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-3" data-test="pick-data-save">
          {{ $t("process-data.pick.save", { count: form.datas.length }) }}
        </sweet-button>
      </b-tab>

      <!-- TKP-172: kütüphane kaynağı → kaynağın verileri (hepsi seçili) → seçilenler düğüm olur -->
      <!-- TKP-210: sekme açılana kadar çizilmez — kaynak listesi (~1100 kütüphane kaynağı) panel açılışında yüklenip çizilmesin -->
      <b-tab lazy data-test="from-datasource-tab">
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("process-data.from-datasource.tab") }}</span>
        </template>
        <!-- TKP-235 m.177–178: üst açıklama; alan adı parantezsiz -->
        <p class="mt-2 mb-2" data-test="from-datasource-intro">{{ $t("process-data.from-datasource.intro") }}</p>
        <h6 class="mt-2">{{ $t("process-data.from-datasource.pick-source") }}</h6>
        <!-- TKP-209: kaynak seçicisi organizasyon + kütüphane + "➕ Yeni veri kaynağı oluştur" (eskiden yalnız kütüphane) -->
        <!-- TKP-236 n.1: bütün kaynaklar alfabetik; verisi tanımlı olanın yanında veri sayısı -->
        <filter-select id="sourceTabDatasourceFilter" ref="sourceTabDatasourceFilter" :options-limit="LIBRARY_SOURCE_LIMIT" :placeholder="$t('datasource.text')" :multiple="false" :custom-label="sourceOptionLabel" @filter="onSourceTabDatasourceSearch" :selected="sourceTab.datasource" @changed="onSourceDatasourceSelect" />
        <!-- TKP-235 m.183–184: "Yeni Veri Kaynağı Ekle" yerine kütüphane eşleşmelerini düzenleme; eski "Kaynak Verileri" sekmesi yan pencerede -->
        <div class="mt-1"><span class="text-primary hand" data-test="edit-source-data-open" @click="openSourceData()">{{ $t("process-data.from-datasource.edit-library") }}</span></div>
        <template v-if="sourceTab.datasource">
          <content-loading v-if="sourceTab.loading" />
          <template v-else>
            <p class="mt-2 mb-1" data-test="from-datasource-hint">{{ $t("process-data.from-datasource.hint") }}</p>
            <div v-if="!sourceTab.rows.length" class="text-muted" data-test="source-empty">
              {{ $t("process-data.from-datasource.empty") }}
              <span class="text-primary hand d-block mt-1" data-test="source-empty-edit-library" @click="openSourceData()">{{ $t("process-data.from-datasource.edit-library") }}</span>
            </div>
            <div v-else>
              <a href="javascript:;" class="small" data-test="source-toggle-all" @click="toggleAllSourceRows()">{{ $t(allSourceChecked ? "common.deselect-all" : "common.select-all-items") }}</a>
              <b-form-checkbox v-for="row in sourceTab.rows" :key="row._id" :checked="row.checked" class="d-block" :data-test="'source-row-' + row._id" @change="(v) => onSourceRowToggle(row._id, v)">
                {{ row.doc.__new || $options.filters.translate(row.doc.name) }}
                <b-badge v-if="row.doc.__new" variant="info" class="ml-1" data-test="source-row-new">{{ $t("process-data.from-datasource.new-badge") }}</b-badge>
              </b-form-checkbox>
            </div>
            <h6 class="mt-3">{{ $t("process-data.from-datasource.add-more") }}</h6>
            <!-- TKP-209: organizasyon verisi + kütüphane + "➕ Yeni veri oluştur" (eskiden yalnız kütüphane) -->
            <filter-select id="sourceTabDataFilter" ref="sourceTabDataFilter" :options-limit="200" :placeholder="$t('data.select')" :multiple="false" @filter="onDataSearch" @changed="onSourceDataAdd" />
            <!-- TKP-229: yeni veri eski veri ekleme ekranıyla (kategorisiyle) açılır; ayrı "yeni veri kategorisi" kutusu kalktı -->
            <span class="text-primary hand d-inline-block mt-1" data-test="new-source-data-open" @click="openNewData('source')">{{ $t("process-data.create-new.link.data") }}</span>
            <sweet-button :loading="sourceTab.saving" :disabled="sourceTab.saving || selectedSourceDocs.length === 0" buttonClass="btn-block mt-3" variant="success" icon="mdi mdi-check" size="sm" data-test="source-save" @click="saveFromSource()">
              {{ $t("process-data.from-datasource.save", { count: selectedSourceDocs.length }) }}
            </sweet-button>
          </template>
        </template>
      </b-tab>

    </b-tabs>
    <!-- TKP-235 m.184: eski "Kaynak Verileri" sekmesi — "Kütüphanede Veri Kaynağı Verilerini Düzenle" ile yan pencere. `lazy` değil: kapanıp açılınca seçilen kaynak kalsın -->
    <right-panel v-if="showLibraryItems" class="float-right" :id="sourceDataPanelId" width="600px" icon="" @hidden="onSourceDataPanelHidden">
      <div class="pl-5 pr-5">
        <h3 data-test="source-data-panel-title">{{ $t("process-data.from-datasource.edit-library") }}</h3>
        <source-data-tab ref="sourceDataTab" :process="process" :pending-sources="form.datasources" @created="onSourceCreated" @data-created="onSourceTabDataCreated" />
      </div>
    </right-panel>

    <div v-else>
      <h2>{{ entityName }} {{ $t("common.update") }}</h2>
      <node-fields :form="form" @datasources="onDatasourcesSelect" @category="onCategorySelect" />
      <!-- TKP-178 md.45 (karar A): kategori değişince "tüm envanterde değiştir" — taban kategori + tüm düğümlerde override temizliği; yalnız onay yetkilisi -->
      <template v-if="categoryWillChange && form.category && !bulkLocked">
        <b-form-checkbox v-model="applyToAll" class="mt-3" data-test="category-all">{{ $t("process-data.category-all") }}</b-form-checkbox>
        <small class="d-block text-muted" data-test="category-all-hint">{{ $t("process-data.category-all-hint") }}</small>
      </template>
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-3">
        {{ $t("common.save") }}
      </sweet-button>
      <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-3 ml-2">
        {{ $t("common.cancel") }}
      </sweet-button>
    </div>
    <!-- TKP-229: "Yeni veri" penceresi (v-if/v-else zincirinin dışında) -->
    <new-data-dialog ref="newData" :process="process" @created="onNewDataCreated" />
  </form>
</template>

<script>
/** TKP-202 n.9: kütüphane kaynakları sekmesinde listelenecek (ve çizilecek) en çok kayıt — bütün liste alfabetik görünsün. */
const LIBRARY_SOURCE_LIMIT = 10000;
/** TKP-240 b.1: seçilen kaynakların organizasyon kayıtları — yeni ad sözlükte açılır, kütüphane kalemi bulunur / açılır, organizasyon kaydı kendisi. */
const organizationDatasources = async (vm, list) => {
  const out = [];
  for (const d of list ?? []) {
    const doc = isNewEntry(d)
      ? await createDictionaryEntry("/datasource", d.__new, { process: vm.process, language: vm.currentLanguage })
      : isLibraryPick(d)
      ? await vm.resolveOrganizationDatasource({ ...d, fromLibrary: undefined })
      : d;
    if (doc && doc._id) out.push(doc);
  }
  return out;
};
import BulkLock from "@/modules/approval/bulk-lock"; // TKP-178 md.45: onay açıkken toplu değişiklik yalnız onay yetkilisine
import { categoryChanged, showCategoryWarnings } from "@/modules/process-data/category-warnings";
import rest from "@/rest-client";
import NodeFields from "./component/process-data-node-fields";
import { addRow, dataIdsOfPairs, libraryDatasourceIdOf, sameLocalizedName, selectedDocs, setAll, sourceDataRows, toggleRow } from "./from-datasource"; // TKP-172
import { uniqueByName, cachedPicker, classifySave, savedIdOf, isLibraryPick, isNewEntry, mergeOrgAndLibrary, newEntry, resolveNodeCategory, searchRequest, summarizeSaves, withCreateOption } from "./unified-picker"; // TKP-184, TKP-218
import NewEntryLink from "./component/new-entry-link"; // TKP-218
import SourceDataTab from "./component/source-data-tab"; // TKP-219
import NewDataDialog from "./component/new-data-dialog"; // TKP-229
import { authorityContext, createDictionaryEntry } from "./new-dictionary-entry"; // TKP-200 m.7/m.13

/**
 * TKP-27 / Faz 6 dilim 6.1 — süreç×veri düğümü formu. Yeni düğüm: kütüphaneden (LibraryItems → `addFromLibrary`, seçili
 * kaynaklarla) ya da organizasyondaki bir veriyi seçerek. Düzenleme: yalnızca düğüm özellikleri (kaynaklar K1, kategori
 * override K4) — süreç ve veri düğümün anahtarıdır, değiştirilmez (backend de yok sayar).
 */
export default {
  mixins: [BulkLock],
  components: { NewEntryLink, NodeFields, SourceDataTab, NewDataDialog },
  data() {
    return { newDataTarget: "pick", form: { data: undefined, datas: [], datasources: [], category: undefined }, entityName: undefined, applyToAll: false, pickSaving: false, dataPicker: null, sourcePicker: null, LIBRARY_SOURCE_LIMIT, sourceTab: { datasource: undefined, rows: [], loading: false, saving: false }, dataCounts: null };
  },
  computed: {
    sourceDataPanelId() {
      return "sidebar-source-data-" + this._uid;
    },
    /** TKP-178 md.45: düzenlemede kategori gerçekten değişiyor mu (kutucuk yalnız o zaman). */
    categoryWillChange() {
      return this.isEditMode && categoryChanged(this.editedEntity && this.editedEntity.category, this.form.category);
    },
    selectedSourceDocs() {
      return selectedDocs(this.sourceTab.rows);
    },
    allSourceChecked() {
      return this.sourceTab.rows.length > 0 && this.sourceTab.rows.every((r) => r.checked);
    },
    process() {
      return this.$store.getters["entityBoxes/process"];
    },
    isUpdating() {
      return this.$store.getters["organizationProcessData/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationProcessData/editedEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationProcessData/isEditMode"];
    },
    showLibraryItems() {
      return !this.isEditMode;
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) {
          this.form = { data: undefined, datas: [], datasources: [], category: undefined };
          return;
        }
        this.form = { _id: v._id, data: v.data, datas: [], datasources: v.datasources ?? [], category: v.category };
        this.entityName = this.$options.filters.translate(v.data?.name);
        this.applyToAll = false;
      },
    },
  },
  methods: {
    /** TKP-235 m.184: kütüphanedeki kaynak–veri eşleşmeleri yan penceresi (eski "Kaynak Verileri" sekmesi). */
    openSourceData() {
      this.$root.$emit("bv::toggle::collapse", this.sourceDataPanelId);
    },
    /** Yan pencerede eşleşme değişmiş olabilir: kaynak listesi (verisi olanlar) ve seçili kaynağın verileri yenilenir. */
    onSourceDataPanelHidden() {
      this.dataCounts = null;
      this.sourcePicker = null;
      const select = this.$refs.sourceTabDatasourceFilter;
      if (select && select.searchChanged) select.searchChanged("*");
      if (this.sourceTab.datasource) this.onSourceDatasourceSelect(this.sourceTab.datasource);
    },
    /** TKP-236 n.1: kütüphane kaynağı başına çalışma alanında görünen veri sayısı (`{ kaynak: sayı }`); panel başına bir kez. */
    async datasourceDataCounts() {
      if (!this.dataCounts) {
        const { data } = await rest.post("/quick-hierarchy/datasource-data/datasources-with-data", {});
        this.dataCounts = data?.counts ?? {};
      }
      return this.dataCounts;
    },
    /** Seçenek etiketi: ad, verisi tanımlıysa "· N veri". */
    sourceOptionLabel(d) {
      const name = this.$options.filters.translate(d && d.name) || "";
      const count = (this.dataCounts || {})[String(libraryDatasourceIdOf(d))];
      return count ? `${name} · ${this.$t("process-data.from-datasource.data-count", { count })}` : name;
    },
    newEntry,
    /** TKP-218: yeni kaydın seçimdeki metni — aramadaki "➕ Yeni … oluştur" ile aynı. */
    newLabel(kind) {
      return (q) => this.$t(`process-data.create-new.${kind}`, { name: q });
    },
    onDatasSelect(items) {
      const list = Array.isArray(items) ? items.filter((i) => i && i._id) : items && items._id ? [items] : [];
      // TKP-229: aramadaki "➕ Yeni veri oluştur" seçimi veri olarak eklenmez — eski veri ekleme ekranı adıyla açılır
      const fresh = list.find(isNewEntry);
      this.form = { ...this.form, datas: uniqueByName(list.filter((i) => !isNewEntry(i))) }; // TKP-230: aynı ad iki kez seçilmez
      if (fresh) this.openNewData("pick", fresh.__new);
    },
    /** TKP-229: "Yeni veri" penceresi; `target` kaydedilen verinin ekleneceği sekme (pick | source). */
    openNewData(target, name = "") {
      this.newDataTarget = target;
      this.$refs.newData.open(name);
    },
    onNewDataCreated(doc) {
      this.dataPicker = null; // açılan veri sonraki aramada listede olsun
      this.resetSourceDataTab("dataPicker"); // TKP-230: Kaynak Verileri'nin veri listesi de
      if (this.newDataTarget === "source") this.onSourceDataAdd(doc);
      // TKP-230: aynı adı taşıyan seçili kayıt (ör. kütüphane kalemi) varsa ikinci kez eklenmez
      else this.form = { ...this.form, datas: uniqueByName([...(this.form.datas || []).filter((d) => String(d._id) !== String(doc._id)), doc]) };
    },
    /** TKP-230: Kaynak Verileri sekmesinin önbelleğe aldığı listeyi sıfırlar (diğer sekmede açılan kayıt orada da görünsün). */
    resetSourceDataTab(cache) {
      const tab = this.$refs.sourceDataTab;
      if (tab) tab[cache] = null;
    },
    /** TKP-230: Kaynak Verileri'nde açılan veri — bu formun veri listesi de yenilenir. */
    onSourceTabDataCreated() {
      this.dataPicker = null;
    },
    /** TKP-221: Kaynak Verileri sekmesinde açılan yeni kaynak, "Veri seç"teki geçici girdinin yerine (kayıtta ikinci kez açılmaz). */
    onSourceCreated({ from, doc }) {
      if (!from || !doc || !doc._id) return;
      this.form = { ...this.form, datasources: (this.form.datasources || []).map((d) => (d && String(d._id) === String(from._id) ? doc : d)) };
      // TKP-230: Kaynak Verileri'nde açılan kaynak "Veri Kaynağı" sekmesinin seçicisinde de hemen görünsün (liste önbellekteydi)
      this.sourcePicker = null;
      this.$nextTick(() => {
        const select = this.$refs.sourceTabDatasourceFilter;
        if (select && select.searchChanged) select.searchChanged("*");
      });
    },
    onDatasourcesSelect(items) {
      this.form = { ...this.form, datasources: items ?? [] };
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item && item._id ? item : undefined };
    },
    /** TKP-184 md.80: organizasyon sözlüğü + kütüphane, tek liste (ada göre sıralı); kütüphane okunamazsa yalnız sözlük. */
    async onDataSearch(value, callback) {
      // TKP-200 m.12: liste bir kez yüklenir, yazılan istemcide süzülür; m.13: listede olmayan ad için "yeni veri oluştur"
      if (!this.dataPicker) {
        this.dataPicker = cachedPicker(async (v) => {
          const request = searchRequest(v, this.currentLanguage);
          const [org, library] = await Promise.all([
            this.$store.dispatch("organizationData/paginateForSearch", request),
            this.$store.dispatch("data/paginateForSearch", request).catch(() => ({ data: { docs: [] } })),
          ]);
          return mergeOrgAndLibrary(org.data?.docs ?? [], library.data?.docs ?? []);
        });
      }
      callback(withCreateOption(await this.dataPicker(value), value, (q) => this.$t("process-data.create-new.data", { name: q })));
    },
    // ---- TKP-172: Veri Kaynağı sekmesi
    /**
     * TKP-209: organizasyon kaynakları + organizasyonda karşılığı olmayan kütüphane kaynakları (`fromLibrary`) + listede olmayan ad
     * için "yeni veri kaynağı oluştur". TKP-184 md.77 / TKP-202 n.9: bütün liste, panel başına bir kez, Türkçe alfabeyle sıralı.
     */
    async onSourceTabDatasourceSearch(value, callback) {
      if (!this.sourcePicker) {
        this.sourcePicker = cachedPicker(async (v) => {
          const request = searchRequest(v, this.currentLanguage, LIBRARY_SOURCE_LIMIT);
          const [org, library] = await Promise.all([
            this.$store.dispatch("organizationDatasource/paginateForSearch", request),
            this.$store.dispatch("datasource/paginateForSearch", request).catch(() => ({ data: { docs: [] } })),
            this.datasourceDataCounts(),
          ]);
          // TKP-202 n.9: sunucu sıralaması ikili (Ç, İ, Ö, Ş, Ü Z'den sonra) — Türkçe alfabeye göre yeniden sırala
          const lang = this.currentLanguage || "tr";
          const label = (d) => String((d && d.name && (d.name[lang] || d.name.tr || d.name.en)) || "").replace(/\s+/g, " ").trim(); // ekranda tek boşluk görünür; çift boşluklu ad ("Güvenlik  Vukuat") sırayı bozmasın
          // TKP-236 n.1 (karar 2026-11-01): bütün kaynaklar listelenir (TKP-235 m.179 süzgeci kalktı); veri sayısı etikette
          return mergeOrgAndLibrary(org.data?.docs ?? [], library.data?.docs ?? []).sort((a, b) => label(a).localeCompare(label(b), lang));
        }, LIBRARY_SOURCE_LIMIT);
      }
      callback(await this.sourcePicker(value)); // TKP-235 m.183: yeni (verisiz) kaynak burada açılmaz — kütüphane düzenleme penceresinden
    },
    async onSourceDatasourceSelect(item) {
      this.sourceTab = { ...this.sourceTab, datasource: item && item._id ? item : undefined, rows: [] };
      // TKP-209: öneri çiftleri kütüphane kaynağına bağlı — organizasyon kaynağında kütüphane bağı üzerinden; yeni kaynakta yok
      const library = libraryDatasourceIdOf(this.sourceTab.datasource);
      if (!library) return;
      this.sourceTab.loading = true;
      try {
        const pairs = await rest.post("/quick-hierarchy/datasource-data/of-datasource", { datasource: library }); // organizasyon kapsamlı uç (TKP-172)
        const ids = dataIdsOfPairs(pairs.data?.docs ?? []);
        const docs = ids.length ? (await this.$store.dispatch("data/paginateForSearch", { options: { page: 1, limit: 1000 }, query: { _id: { value: { $in: ids }, isObject: true } } })).data?.docs ?? [] : [];
        this.sourceTab.rows = sourceDataRows(pairs.data?.docs ?? [], docs.map((d) => ({ ...d, fromLibrary: true }))); // TKP-209: kayıtta kütüphaneden-ekle ucu
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.sourceTab.loading = false;
      }
    },
    onSourceRowToggle(id, checked) {
      this.sourceTab.rows = toggleRow(this.sourceTab.rows, id, checked);
    },
    toggleAllSourceRows() {
      this.sourceTab.rows = setAll(this.sourceTab.rows, !this.allSourceChecked);
    },
    onSourceDataAdd(doc) {
      if (isNewEntry(doc)) return this.openNewData("source", doc.__new); // TKP-229
      if (doc && doc._id) this.sourceTab.rows = addRow(this.sourceTab.rows, doc);
    },
    /** Kütüphane kaynağının organizasyon karşılığı: önce kütüphane bağı, sonra ad eşleşmesi (eski kayıtlarda bağ yok), yoksa kütüphaneden açılır. */
    async resolveOrganizationDatasource(library) {
      const byLink = await this.$store.dispatch("organizationDatasource/paginateForSearch", { options: { limit: 1 }, query: { libraryItem: { value: library._id, isObject: true } } });
      if (byLink.data?.docs?.[0]) return byLink.data.docs[0];
      const name = (library.name && (library.name.tr || library.name.en)) || "";
      const byName = name ? await this.$store.dispatch("organizationDatasource/paginateForSearch", { options: { limit: 20 }, query: { name: { value: name } } }) : { data: { docs: [] } };
      const exact = (byName.data?.docs ?? []).find((d) => sameLocalizedName(d.name, library.name));
      if (exact) return exact;
      // TKP-200 m.20: süreç yöneticisi için yetki süreç bağlamıyla sorulur; TKP-236 n.3: gölge süreçte sürecin birimiyle
      return (await this.$store.dispatch("organizationDatasource/addFromLibrary", { libraryItem: library, ...authorityContext(this.process) })).data;
    },
    /** Seçilen kaynağın organizasyon karşılığı (yoksa kütüphaneden açılır) → her seçili veri için mevcut "kütüphaneden ekle" ucu. */
    async saveFromSource() {
      const docs = this.selectedSourceDocs;
      if (!docs.length || !(await this.confirm(this.$t("process-data.from-datasource.confirm", { count: docs.length })))) return;
      this.sourceTab.saving = true;
      try {
        // TKP-209: yeni veri kategorisiz açılamaz (sözlük kuralı) — hiçbir şey yazılmadan uyarılır
        const orgDatasource = await this.organizationDatasourceOf(this.sourceTab.datasource);
        const datasources = orgDatasource && orgDatasource._id ? [{ _id: orgDatasource._id }] : [];
        const results = [];
        for (const doc of docs) {
          try {
            const response = await this.saveItem(doc, datasources, undefined); // TKP-229: yeni veri kaydedilmeden önce kendi kategorisiyle açıldı
            results.push({ status: classifySave(response), response });
          } catch (error) {
            results.push({ status: classifySave(undefined, error) });
          }
        }
        const summary = summarizeSaves(results);
        this.$toast.success(this.$t("process-data.from-datasource.done", summary));
        this.dataPicker = null; // yeni açılan kayıtlar sonraki aramada listede olsun
        this.sourcePicker = null;
        this.sourceTab = { datasource: undefined, rows: [], loading: false, saving: false };
        this.$emit("onSave", { savedIds: results.map((r) => savedIdOf(r.response)).filter(Boolean) }); // TKP-203: kopyalama önerisi
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.sourceTab.saving = false;
      }
    },
    /**
     * TKP-184 md.80 — tek sekmeden kayıt: seçilen her veri ayrı istek (taslak kapısı öğe başına çalışır). Organizasyon verisi
     * düğüm oluşturma ucuyla, kütüphane verisi "kütüphaneden ekle" ucuyla; kaynaklar ve süreç bazında kategori hepsine.
     * md.75: sürece zaten bağlı veri yeni bir kaynakla seçildiyse sunucu kaynak listesini birleştirir ("kaynağı eklendi").
     */
    async saveSelected() {
      const items = this.form.datas || [];
      if (!items.length || !(await this.confirm(this.$t("alert.approve")))) return;
      const ref = (i) => (i && i._id ? { _id: i._id } : undefined);
      this.pickSaving = true;
      try {
        const category = await resolveNodeCategory(this.$store.dispatch, this.form.category, this.process); // md.76
        // TKP-200 m.13: yeni veri kategorisiz açılamaz (sözlük kuralı)
        if (items.some(isNewEntry) && !category) {
          this.$toast.warning(this.$t("process-data.create-new.category-required"));
          return;
        }
        // TKP-200 m.7: listede olmayan kaynak önce organizasyon sözlüğünde açılır
        // TKP-240 b.1: kütüphaneden seçilen kaynak organizasyon karşılığına çevrilir (yoksa kütüphaneden açılır)
        const datasources = (await organizationDatasources(this, this.form.datasources)).map(ref);
        const results = [];
        for (const item of items) {
          try {
            const response = await this.saveItem(item, datasources, category);
            results.push({ status: classifySave(response), response });
          } catch (error) {
            results.push({ status: classifySave(undefined, error), error });
          }
        }
        const summary = summarizeSaves(results);
        const failed = results.find((r) => r.status === "failed");
        if (items.length === 1 && failed) this.$handleHttpErrorByStatusCode(failed.error);
        else this.$toast[summary.failed ? "warning" : "success"](this.$t("process-data.from-datasource.done", summary));
        if (items.length === 1 && results[0].response) showCategoryWarnings(this, results[0].response, { changed: !!category });
        if (summary.created + summary.draft + summary.linked > 0) {
          this.dataPicker = null; // yeni açılan kayıtlar sonraki aramada listede olsun
          this.form = { data: undefined, datas: [], datasources: [], category: undefined };
          this.$emit("onSave", { savedIds: results.map((r) => savedIdOf(r.response)).filter(Boolean) }); // TKP-203: kopyalama önerisi
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.pickSaving = false;
      }
    },
    /**
     * Tek verinin sürece eklenmesi (iki sekme de): yeni ad önce organizasyon sözlüğünde açılır (TKP-200 m.13), kütüphane kalemi
     * "kütüphaneden ekle" ucuyla, organizasyon verisi düğüm oluşturma ucuyla. `category` süreç bazında kategori (yoksa yok).
     */
    async saveItem(item, datasources, category) {
      const ref = (i) => (i && i._id ? { _id: i._id } : undefined);
      if (isNewEntry(item)) {
        const created = await createDictionaryEntry("/data", item.__new, { category, process: this.process, language: this.currentLanguage });
        return this.$store.dispatch("organizationProcessData/save", { process: ref(this.process), data: ref(created), datasources, category: ref(category) });
      }
      if (isLibraryPick(item)) return this.$store.dispatch("organizationProcessData/addFromLibrary", { process: this.process, libraryItem: { ...item, fromLibrary: undefined }, datasources, category });
      return this.$store.dispatch("organizationProcessData/save", { process: ref(this.process), data: ref(item), datasources, category: category ? ref(category) : null });
    },
    /** TKP-209: "Veri Kaynağı" sekmesinde seçilen kaynağın organizasyon karşılığı — yeni ad sözlükte açılır, kütüphane kalemi bulunur/açılır, organizasyon kaynağı kendisi. */
    async organizationDatasourceOf(datasource) {
      if (isNewEntry(datasource)) return createDictionaryEntry("/datasource", datasource.__new, { process: this.process, language: this.currentLanguage });
      if (isLibraryPick(datasource)) return this.resolveOrganizationDatasource({ ...datasource, fromLibrary: undefined });
      return datasource;
    },
    payload() {
      const ref = (i) => (i && i._id ? { _id: i._id } : undefined);
      return {
        _id: this.form._id,
        process: ref(this.process),
        data: ref(this.form.data),
        datasources: (this.form.datasources ?? []).map(ref).filter(Boolean),
        category: this.form.category ? ref(this.form.category) : null,
      };
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) return;
      // TKP-128: "kategori değişti mi" kayıttan ÖNCE hesaplanır — CRUD `update` sonrası `editedEntity` sıfırlanıyor ve
      // izleyici formu boşaltıyor; sonradan hesaplanınca her zaman "değişmedi" çıkıp uyarı hiç gösterilmiyordu.
      const changed = categoryChanged(this.isEditMode ? this.editedEntity && this.editedEntity.category : null, this.form.category);
      const all = this.applyToAll && changed && !!this.form.category && this.isEditMode; // TKP-178 md.45
      if (all && !(await this.confirm(this.$t("process-data.category-all-confirm")))) return;
      // kayıt sonrası store `editedEntity`i sıfırlar ve izleyici formu boşaltır — kimlik ve kategori ÖNCE yakalanır (TKP-128 dersi)
      const nodeId = this.form._id;
      try {
        // TKP-184 md.76: kütüphaneden seçilen kategori önce organizasyon kategorisine çevrilir
        const category = await resolveNodeCategory(this.$store.dispatch, this.form.category, this.process || (this.editedEntity && this.editedEntity.process));
        const datasources = (await organizationDatasources(this, this.form.datasources)).map((d) => ({ _id: d._id })); // TKP-240 b.1
        const response = await this.$store.dispatch("organizationProcessData/save", { ...this.payload(), datasources, category: category && category._id ? { _id: category._id } : null });
        this.$toast.success(this.$t("common.success"));
        if (all) {
          const { data } = await this.$store.dispatch("organizationProcessData/updateCategoryForAll", { _id: nodeId, category });
          this.$toast.info(this.$t("process-data.category-all-done", { nodes: data && data.nodes, cleared: data && data.overridesCleared }));
        } else showCategoryWarnings(this, response, { changed });
        this.$emit("onSave");
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.commit("organizationProcessData/editedEntity", undefined);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
    },
  },
};
</script>
